'use client';

import { useLocale, useRouterPush } from '@ianesthesie-kit/core';
import { useCurrentHospital } from '@/modules/appContext';
import { useEffect } from 'react';
import { HospitalService } from '@/modules/hospital';

export const useDefaultRedirectPerHospital = () => {
  const push = useRouterPush();
  const locale = useLocale();
  const {
    queryResult: { currentData: hospital },
    isUnstable
  } = useCurrentHospital();
  useEffect(() => {
    if (!isUnstable) {
      let path = HospitalService.isUsapHospital(hospital)
        ? '/patients/preop/surgery-planning'
        : '/patients/preop';
      path = `${locale}${path}`;
      push(path);
    }
  }, [push, locale, isUnstable, hospital]);
};
